import { render, staticRenderFns } from "./sspPage.vue?vue&type=template&id=2ba9e8a2&scoped=true&"
import script from "./sspPage.vue?vue&type=script&lang=js&"
export * from "./sspPage.vue?vue&type=script&lang=js&"
import style0 from "./sspPage.vue?vue&type=style&index=0&id=2ba9e8a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9e8a2",
  null
  
)

export default component.exports